/**
 * Determines if a feature is turned on in the build manifest
 * @param core core state
 * @param feature name of the feature (favorites, hompeage, category, etc).  See manifest.json
 * @return True if the feature is active
 */
export function isFeatureEnabled(core, feature) {
    const envVars = core.envVars || {};
    const features = envVars.features || [];
    return features.indexOf(feature) >= 0;
}
